<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ErrorBag } from 'vee-validate';
import _colors from '@/helpers/colors';

@Component
export default class ErrorsMixin extends Vue {
  @Prop({ required: false })
  public readonly successState: boolean | null | undefined;

  public isNotDefined(model: any): boolean {
    return model === undefined || model === null || model === '';
  }

  public isSuccess(model: any, errName: string): boolean | null {
    if (this.successState !== undefined) {
      return this.successState;
    }
    if (this.isNotDefined(model)) {
      return false;
    }
    for (const e of this.errorBag.items) {
      if (e.field === errName) {
        return false;
      }
    }
    return true;
  }

  public getColor(model: any, errName: any): string {
    if (this.isNotDefined(model)) {
      return _colors['vv-grey'];
    } else {
      return this.isSuccess(model, errName)
        ? _colors['vv-green']
        : _colors['vv-red'];
    }
  }

  public getErrorMessages(key: string): string[] {
    const errors = this.errorBag.collect(key);
    return errors instanceof Array ? errors.map(f => f.msg) : [];
  }

  public removeError(field: string) {
    this.errorBag.remove(field);
  }

  public addError(field: string, msg: string, id?: string) {
    this.errorBag.add({
      field,
      msg,
      id
    });
  }

  public hideErrorDetails(field: string): boolean {
    return !this.getErrorMessages(field).length;
  }

  get errorBag(): ErrorBag {
    return this.$validator.errors;
  }

  get errorsLength(): number {
    return this.errorBag.items.length;
  }
}
</script>

<style></style>
